module.exports = __webpack_public_path__ + "img/logo.bbcc7369.svg";